module.exports = __webpack_public_path__ + "static/img/placeholder.4589796.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Templates/placeholder.png
// module id = 265
// module chunks = 2 5